import React, { useState } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import ClosedcandidateForm from "../../components/closedcandidates/ClosedcandidateForm";
import { convertToFormData } from "../../shared/upload";
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL
} from "../../shared/enums/closedcandidates_enum";
import { useUpdateClosedcandidate, useSingleClosedcandidate, useGetDropdownOptions } from "../../shared/hooks/UseClosedcandidate";
// import { useSelectAllClosedcandidate } from "../../shared/hooks/UseClosedcandidate";

const EditClosedcandidate = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSingleClosedcandidate(match.params.id);
  const [updateData] = useUpdateClosedcandidate();
  const { closedcandidate_loading, closedcandidate, edit_closedcandidate_loading } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);



  const [dropdownOptions] = useGetDropdownOptions();
  const submitFormClicked = async values => {
    const data = await convertToFormData({ values, featuredImage });
    await updateData(closedcandidate._id, data);
    history.goBack();
  };



  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!closedcandidate_loading ? (
              closedcandidate && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {closedcandidate[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to={`/${LINK_URL}`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${closedcandidate._id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <ClosedcandidateForm
                    data={closedcandidate}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_closedcandidate_loading}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditClosedcandidate;
